import './App.css';
import 'rsuite/dist/rsuite.min.css';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Main from './components/main';
import View from './components/view';
import AnalyticsView from './components/analytics/orcAnalytics';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard/:panel/"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          <Route path="/view/:key" element={<View />} />
          <Route path="/analytics/:key" element={<AnalyticsView />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
